module.exports = __webpack_public_path__ + "media/components/assets/img/logo-b3835d433fe7d162f3bd7e3a54bc2cdf.png";